import React, { type HTMLAttributes } from 'react';
import cx from 'classnames';
import ButtonOrLink from '../ButtonOrLink';
import stylesheet from './ToggleTag.css';

export type ToggleTagProps = {
  children: React.ReactNode;
  onClick?: (value: boolean) => void;
  disabled?: boolean;
  className?: string;
  /** Specify if toggle is true/false */
  value: boolean;
} & HTMLAttributes<HTMLButtonElement>;

const ToggleTag = React.forwardRef<HTMLButtonElement, ToggleTagProps>(
  function ToggleTag(
    { className, children, onClick, disabled = false, value = false, ...props },
    ref,
  ) {

    const handleClick = (e: boolean) => {
      if (!disabled && onClick) {
        onClick(e);
      }
    };

    return (
      <ButtonOrLink
        ref={ref}
        className={cx(
          stylesheet.root,
          {
            [stylesheet.toggled]: value,
            [stylesheet.disabled]: disabled,
          },
          className,
        )}
        onClick={() => handleClick(!value)}
        {...props}
      >
        {children}
      </ButtonOrLink>
    );
  },
);

export default ToggleTag;
